import {defineComponent} from 'vue';
import DateUtil from '@/app/shared/helpers/date-util';

export default defineComponent({
    compatConfig: {
        MODE: 3
    },
    name: 'KlDatepicker',
    props: {
        modelValue: { type: Array as () => String[], required: false, default: undefined },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {

        const onUpdate = (newValue: string[]) => {
            // KLIP specific consistent parsing/formatting
            const dateString = DateUtil.formatDate(DateUtil.parseToDayJs(newValue));
            emit('update:modelValue', [dateString]);
        }

        return {
            onUpdate,
        }
    }
});
